import { render } from "./FoerderorganisationRollenfreigabenList.pug?vue&type=template&id=2c79f519&lang=pug"
import script from "./FoerderorganisationRollenfreigabenList.js?vue&type=script&lang=js"
export * from "./FoerderorganisationRollenfreigabenList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__